
import { useMemo, useState, useEffect } from 'react';
import MaterialReactTable from 'material-react-table';
import useUtils from '../../../utiles/useUtiles';
import { IUserIBVFailed } from '../../../utiles/interfaces';
import util from '../../../utiles/miniUtiles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { Alert } from 'react-bootstrap';


const IBVGuidsReport = () => {

	const { axiosRequest, baseUrl, toastInstance, loadingScreen } = useUtils()
	const axios = axiosRequest();
	const toast = toastInstance();

	const [record, setRecord] = useState<any>({ count: 0, rows: [] });
	const [loading, setLoading] = useState<boolean>(false);
	const [searchText, setSearchText] = useState<string>('')
	const [pagination, setPagination] = useState<any>({
		pageIndex: 0,
		pageSize: 10
	});

	useEffect(() => {
		fetchLogs();
	}, [pagination.pageIndex, pagination.pageSize]);


	const columns = useMemo(
		() => [
			{
				accessorKey: 'id',
				header: 'GUID-ID',
				minSize: 50,
				maxSize: 120,
				Cell: ({ cell }: any) => {
					const row: IUserIBVFailed = cell.row.original;
					return <span>{row.id}</span>;
				},
			}, {
				accessorKey: 'name',
				header: 'Name',
				minSize: 50,
				maxSize: 120,
				Cell: ({ cell }: any) => {
					const row: IUserIBVFailed = cell.row.original;
					return <span>{row.name}</span>;
				},
			},
			{
				accessorKey: 'email',
				header: 'Email',
				Cell: ({ cell }: any) => {
					const row: IUserIBVFailed = cell.row.original;
					return <span>{row.email}</span>;
				},
			}, {
				accessorKey: 'reference',
				header: 'Reference',
				Cell: ({ cell }: any) => {
					const row: IUserIBVFailed = cell.row.original;
					return <span>{row.reference}</span>;
				},
			},
			{
				accessorKey: 'reponse',
				header: 'Response',
				Cell: ({ cell }: any) => {
					const row: IUserIBVFailed = cell.row.original;
					return <span>{row.reponse === 1 ?
						<FontAwesomeIcon color='#75ba75' icon={faThumbsUp} /> : "Didn't received response"}</span>;
				},
			},
			{
				accessorKey: 'createdAt',
				header: 'Date',
				Cell: ({ cell }: any) => {
					const row: IUserIBVFailed = cell.row.original;
					return <span>{util.humanDate(row.createdAt)}</span>;
				},
			},
		],
		[],
	);

	const fetchLogs = async () => {
		setLoading(true);
		var queryString = `page=${pagination.pageIndex}&pageSize=${pagination.pageSize}&failed=1`;
		if (searchText) {
			queryString += `&email=${searchText}`
		}

		const request = await axios.get(`${baseUrl()}/ibv/failed_guids?${queryString}`);
		const { error, result } = request.data;
		setLoading(false);
		if (error) {
			toast.error('Error to fetch logs');
		} else {
			setRecord({
				count: result['count'],
				rows: result['rows']
			});
		}
	};

	return (
		<>
			<div className='mb-4 row'>
				<div className='col-md-10'>
					<input type={"text"} name="searchText" placeholder="Email" className="form-control" autoComplete='new-password' onChange={(e) => setSearchText(e.target.value)} />
				</div>
				<div className='col-md-2'>
					<button type="button" className="btn btn-md btn-custom-secondary" onClick={fetchLogs}>Search</button>
				</div>
			</div>
			<div>
				<Alert variant='info' >
					<p>Here you can see the list of GUIDs that failed to verify. You can search by email.</p>
				</Alert>
			</div>
			<MaterialReactTable
				columns={columns}
				data={record?.rows}
				rowCount={record?.count}
				enableColumnOrdering={false}
				enableRowSelection={false}
				enableSelectAll={false}
				enableColumnActions={false}
				manualPagination
				onPaginationChange={setPagination}
				state={{ pagination }}
				enableSorting={false}
				enableGlobalFilter={false}
				enableFullScreenToggle={false}
				enableDensityToggle={false}
				enableHiding={false}
				enableColumnFilters
				enableFilters={false}
			/>
			{loadingScreen(loading)}
		</>
	);
}

export default IBVGuidsReport;